export default {"src":"/_next/static/media/bassin.58a082da.svg","height":64,"width":110,"blurWidth":0,"blurHeight":0};